import serialize from 'form-serialize';

const getCart = () => {
	return fetch('/cart.json', {
		crossDomain: true,
		credentials: 'same-origin',
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json();
		})
		.catch((error) => {
			console.error(error);
		});
};

const getCollection = (handle) => {
	return fetch(`/collections/${handle}/products.json`, {
		crossDomain: true,
		credentials: 'same-origin',
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json();
		})
		.catch((error) => {
			console.error(error);
		});
};

const addVariantToCart = (id, quantity = 1, properties = null) => {
	return fetch('/cart/add.json', {
		crossDomain: true,
		method: 'POST',
		credentials: 'same-origin',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ id, quantity, properties }),
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return getCart();
		})
		.catch((error) => {
			console.error(error);
		});
};

const addFormToCart = (form) => {
	const data = serialize(form, { hash: true });

	return fetch('/cart/add.json', {
		crossDomain: true,
		method: 'POST',
		credentials: 'same-origin',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(data),
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return getCart();
		})
		.catch((error) => {
			console.error(error);
		});
};

const updateCartItem = (key, quantity) => {
	return fetch('/cart/change.json', {
		crossDomain: true,
		method: 'POST',
		credentials: 'same-origin',
		body: JSON.stringify({ id: key, quantity: quantity }),
		headers: { 'Content-Type': 'application/json' },
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return getCart();
		})
		.catch((error) => {
			console.error(error);
			return error;
		});
};

const updateCartAtribute = (key, value) => {
	let data = { attributes: {} };
	data.attributes[key] = value;

	return fetch('/cart/update.json', {
		crossDomain: true,
		method: 'POST',
		credentials: 'same-origin',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(data),
	})
		.then((response) => {
			// console.log('update cart attribute', response )
			if (!response.ok) {
				console.error('announcement bar error', response.statusText);
			}
			return response.json();
		})
		.catch((error) => {
			console.error(error);
		});
};

export {
	getCart,
	getCollection,
	addVariantToCart,
	addFormToCart,
	updateCartItem,
	updateCartAtribute,
};
